import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faAd,
  faAt,
  faBellConcierge,
  faBird,
  faBlockQuestion,
  faBook,
  faBriefcase,
  faBrowser,
  faBuildingColumns,
  faCalculator,
  faCalendar,
  faCarBuilding,
  faCoins,
  faFilm,
  faGalleryThumbnails,
  faGraduationCap,
  faHatChef,
  faHotel,
  faImages,
  faIndustry,
  faInfoCircle,
  faLocationDot,
  faMagnifyingGlassArrowRight,
  faMagnifyingGlassPlus,
  faMailbox,
  faMap,
  faMessageQuestion,
  faMoneyBill,
  faNewspaper,
  faPlane,
  faPodcast,
  faQuestion,
  faSearch,
  faShoppingCart,
  faSpiderWeb,
  faStar,
  faSunglasses,
  faTypewriter,
  faVideo,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { ProjectKeywordGq } from '../../../../../graphql/projects/models/ProjectKeywordGq';
import { SerpFeatureSet1Gq } from '../../../../../graphql/projects/models/SerpFeatureSet1Gq';
import { SerpFeatureSet2Gq } from '../../../../../graphql/projects/models/SerpFeatureSet2Gq';
import { SerpStatusGq } from '../../../../../graphql/projects/models/SerpStatusGq';
import VoxelLoadingSpinner from '../../../../voxel/Animation/VoxelLoadingSpinner';
import VoxelDataTableCell from '../../../../voxel/DataTable/VoxelDataTableCell';
import VoxelTooltipShort from '../../../../voxel/Tooltip/VoxelTooltipShort';

export interface TableCellSERPFeaturesProps {
  keyword: ProjectKeywordGq;
  projectDomainId: number;
  serpStatus: SerpStatusGq;
}

const serp1FeatureProps: SerpFeatureProps[] = [
  { label: 'answer box', icon: faBlockQuestion, bitCheck: SerpFeatureSet1Gq.answer_box },
  { label: 'app', icon: faBrowser, bitCheck: SerpFeatureSet1Gq.app },
  { label: 'carousel', icon: faGalleryThumbnails, bitCheck: SerpFeatureSet1Gq.carousel },
  { label: 'commercial units', icon: faIndustry, bitCheck: SerpFeatureSet1Gq.commercial_units },
  { label: 'currency box', icon: faCoins, bitCheck: SerpFeatureSet1Gq.currency_box },
  { label: 'events', icon: faCalendar, bitCheck: SerpFeatureSet1Gq.events },
  //{ label: 'featured snippet', icon: a, bitCheck: SerpFeatureSet1Gq.featured_snippet }, // This is on by default ...
  {
    label: 'find results on',
    icon: faMagnifyingGlassPlus,
    bitCheck: SerpFeatureSet1Gq.find_results_on,
  },
  { label: 'found on the web', icon: faSpiderWeb, bitCheck: SerpFeatureSet1Gq.found_on_the_web },
  { label: 'google flights', icon: faPlane, bitCheck: SerpFeatureSet1Gq.google_flights },
  { label: 'google hotels', icon: faHotel, bitCheck: SerpFeatureSet1Gq.google_hotels },
  { label: 'google posts', icon: faMailbox, bitCheck: SerpFeatureSet1Gq.google_posts },
  { label: 'google reviews', icon: faStar, bitCheck: SerpFeatureSet1Gq.google_reviews },
  { label: 'hotels pack', icon: faCarBuilding, bitCheck: SerpFeatureSet1Gq.hotels_pack },
  { label: 'images', icon: faImages, bitCheck: SerpFeatureSet1Gq.images },
  { label: 'jobs', icon: faBriefcase, bitCheck: SerpFeatureSet1Gq.jobs },
  { label: 'knowledge graph', icon: faBook, bitCheck: SerpFeatureSet1Gq.knowledge_graph },
  { label: 'local pack', icon: faLocationDot, bitCheck: SerpFeatureSet1Gq.local_pack },
  { label: 'local services', icon: faBellConcierge, bitCheck: SerpFeatureSet1Gq.local_services },
  { label: 'map', icon: faMap, bitCheck: SerpFeatureSet1Gq.map },
  { label: 'math solver', icon: faCalculator, bitCheck: SerpFeatureSet1Gq.math_solver },
  { label: 'mention carousel', icon: faAt, bitCheck: SerpFeatureSet1Gq.mention_carousel },
  //{ label: 'organic', icon: a, bitCheck: SerpFeatureSet1Gq.organic }, // Everything has organic ...
  { label: 'paid', icon: faAd, bitCheck: SerpFeatureSet1Gq.paid },
  { label: 'people also ask', icon: faQuestion, bitCheck: SerpFeatureSet1Gq.people_also_ask },
  { label: 'people also search', icon: faSearch, bitCheck: SerpFeatureSet1Gq.people_also_search },
  { label: 'podcasts', icon: faPodcast, bitCheck: SerpFeatureSet1Gq.podcasts },
  { label: 'popular products', icon: faSunglasses, bitCheck: SerpFeatureSet1Gq.popular_products },
  {
    label: 'questions and answers',
    icon: faMessageQuestion,
    bitCheck: SerpFeatureSet1Gq.questions_and_answers,
  },
  { label: 'recipes', icon: faHatChef, bitCheck: SerpFeatureSet1Gq.recipes },
];

const serp2FeatureProps: SerpFeatureProps[] = [
  {
    label: 'related searches',
    icon: faMagnifyingGlassArrowRight,
    bitCheck: SerpFeatureSet2Gq.related_searches,
  },
  {
    label: 'scholarly articles',
    icon: faGraduationCap,
    bitCheck: SerpFeatureSet2Gq.scholarly_articles,
  },
  { label: 'shopping', icon: faShoppingCart, bitCheck: SerpFeatureSet2Gq.shopping },
  { label: 'short videos', icon: faFilm, bitCheck: SerpFeatureSet2Gq.short_videos },
  { label: 'stocks box', icon: faMoneyBill, bitCheck: SerpFeatureSet2Gq.stocks_box },
  { label: 'top sights', icon: faBuildingColumns, bitCheck: SerpFeatureSet2Gq.top_sights },
  { label: 'top stories', icon: faNewspaper, bitCheck: SerpFeatureSet2Gq.top_stories },
  { label: 'twitter', icon: faBird, bitCheck: SerpFeatureSet2Gq.twitter },
  { label: 'video', icon: faVideo, bitCheck: SerpFeatureSet2Gq.video },
  { label: 'visual stories', icon: faTypewriter, bitCheck: SerpFeatureSet2Gq.visual_stories },
];

const TableCellSERPFeatures: React.FC<TableCellSERPFeaturesProps> = ({
  keyword,
  projectDomainId,
  serpStatus,
}) => {
  const projectDomainRank = keyword.domainRanks?.find(
    (dr) => !!dr?.rank && dr?.domainId === projectDomainId
  );

  if (!keyword.serpResultTime)
    return (
      <VoxelDataTableCell align={'left'}>
        <div className="w-full flex flex-row justify-start">
          {serpStatus === SerpStatusGq.PROCESSING && <VoxelLoadingSpinner />}
        </div>
      </VoxelDataTableCell>
    );

  return (
    <VoxelDataTableCell align={'left'}>
      <div className={'flex flex-row items-center justify-start gap-2'}>
        {!!keyword.serpHasFeaturedSnippet && (
          <VoxelTooltipShort message={'featured snippet'}>
            {projectDomainRank?.featuredSnippet ? (
              <FontAwesomeIcon icon={faInfoCircle} className="text-voxel-orange-700 opacity-70" />
            ) : (
              <FontAwesomeIcon icon={faInfoCircle} className="text-voxel-gray-400" />
            )}
          </VoxelTooltipShort>
        )}

        {serp1FeatureProps.map((subProps) => (
          <SerpFeature key={subProps.bitCheck} {...subProps} value={keyword.serpFeaturesSet1} />
        ))}

        {serp2FeatureProps.map((subProps) => (
          <SerpFeature key={subProps.bitCheck} {...subProps} value={keyword.serpFeaturesSet2} />
        ))}
      </div>
    </VoxelDataTableCell>
  );
};

interface SerpFeatureProps {
  label: string;
  bitCheck: number;
  icon: IconProp;
}

const SerpFeature: React.FC<{
  label: string;
  value: number;
  bitCheck: number;
  icon: IconProp;
}> = ({ label, value, bitCheck, icon }) => {
  if (value & bitCheck)
    return (
      <VoxelTooltipShort message={label} key={bitCheck}>
        <FontAwesomeIcon icon={icon} className="text-voxel-gray-400" />
      </VoxelTooltipShort>
    );
  else return null;
};

export default TableCellSERPFeatures;
